import type { ProcessType } from 'shared/domain/process/types/model';
import type { HashMap } from 'shared/types/commonView';

export interface ProcessBadgeData {
  color: string;
  code: string;
}

/** The list with the process the server saved in place of its previous version. */
export function replaceProcess(processes: ProcessType[], saved: ProcessType): ProcessType[] {
  return processes.map((process) => (process._id === saved._id ? saved : process));
}

export function indexProcessesById(processes: ProcessType[]): HashMap<ProcessType> {
  return Object.fromEntries(processes.map((process) => [process._id, process]));
}

/** Badges (color, code) of the processes using each workflow, for workflow lists. */
export function groupProcessBadgesByWorkflowId(processes: ProcessType[]): Record<string, ProcessBadgeData[]> {
  const badges: Record<string, ProcessBadgeData[]> = {};
  processes.forEach(({ workflowId, color, code }) => {
    if (workflowId) {
      (badges[workflowId] ??= []).push({ color, code });
    }
  });
  return badges;
}
